import { FormControl, MenuItem, Select, Typography } from '@mui/material';
import React from 'react';

type ListItemsProps = {
  name: string;
  options: any[];
  label: string;
  value: string | number;
  onChange: (event: any) => void;
}

const ListItems: React.FC<ListItemsProps> = ({ options, name, label, value, onChange}) => {

  console.log(options)
  return (
    <FormControl sx={{ '.MuiSvgIcon-root': { color: 'rgba(68, 68, 68, 1)' } }} fullWidth>
      <Typography mb={'7px'}>{label}</Typography>
      <Select
        id={name}
        name={name}
        required
        sx={{ color: '#000', border: '1px solid #000' }}
        value={value}
        onChange={onChange}
      >
        <MenuItem key={'all'} value={'all'}>{'Todos'}</MenuItem>
        {
          options?.map((item) => <MenuItem
            key={String(item.id || item.label)}
            value={item.id || item.label}>{`${item.label}`}</MenuItem>)
        }
      </Select>
    </FormControl>
  );
};

export default ListItems;